// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "LeftNavWrapper-module--bx--text-truncate--end--czko5";
export var bxTextTruncateFront = "LeftNavWrapper-module--bx--text-truncate--front--yoTuE";
export var expanded = "LeftNavWrapper-module--expanded--k2ILz";
export var leftNavWrapper = "LeftNavWrapper-module--leftNavWrapper--ih7LY";
export var useHeaderNavStyles = "LeftNavWrapper-module--useHeaderNavStyles--Oe45O";